import { SMALL_ELEMENT_MAX_SIDE_PX } from './PdfCardElement.constants';
import { smallElementCornerHandleStyles } from './PdfCardElement.styles';

// re-resizable's default 20px corner handles fully cover a small element (e.g. a 14pt checkbox),
// so clicks land on a handle instead of the field. Small elements get compact corner handles.
export const getResizeHandleConfig = ({ width, height, isEnabledResizing }) => ({
  enableResizing: {
    bottomRight: isEnabledResizing,
    topRight: isEnabledResizing,
    bottomLeft: isEnabledResizing,
    topLeft: isEnabledResizing,
  },
  resizeHandleStyles:
    Math.min(width, height) < SMALL_ELEMENT_MAX_SIDE_PX
      ? smallElementCornerHandleStyles
      : undefined,
});
